import React from 'react';

import { Typography } from '@occc/ui-design-system';
import { EarningMechanismFragment } from '@occc/graphql';
import { earningMechanismHelper } from '@occc-app/offerHelpers/utils/earningMechanismHelper';

import { TotalEligiblePurchase } from './TotalEligiblePurchase';
import { ExternalFulfillment } from './ExternalFulfillment';
import { TotalEligiblePurchaseOverTime } from './TotalEligiblePurchaseOverTime';
import { ProductPurchase } from './ProductPurchase';
import { PointSpend } from './PointSpend';
import { ProductDiscount } from './ProductDiscount';
import { TotalSpendOverTime } from './TotalSpendOverTime';
import { TransactionDiscount } from './TransactionDiscount';
import { VarietyDiscount } from './VarietyDiscount';
import { Visits } from './Visits';
import { LoyaltyEvent } from './LoyaltyEvent';
import { MembershipEvent } from './MembershipEvent';
import { VarietyPurchase } from './VarietyPurchase';
import { VarietyPurchaseOverTime } from './VarietyPurchaseOverTime';

interface IEarningMechanismConfigurationProps {
  earningMechanism: EarningMechanismFragment;
}

export const EarningMechanismConfiguration: React.FC<IEarningMechanismConfigurationProps> = ({
  earningMechanism,
}) => {
  if (earningMechanismHelper.isTotalEligiblePurchase(earningMechanism)) {
    return <TotalEligiblePurchase earningMechanism={earningMechanism} />;
  }
  if (earningMechanismHelper.isExternalFulfillment(earningMechanism)) {
    return <ExternalFulfillment />;
  }
  if (earningMechanismHelper.isTotalEligiblePurchaseOverTime(earningMechanism)) {
    return <TotalEligiblePurchaseOverTime earningMechanism={earningMechanism} />;
  }
  if (earningMechanismHelper.isProductPurchase(earningMechanism)) {
    return <ProductPurchase earningMechanism={earningMechanism} />;
  }
  if (earningMechanismHelper.isPointSpend(earningMechanism)) {
    return <PointSpend earningMechanism={earningMechanism} />;
  }
  if (earningMechanismHelper.isProductDiscount(earningMechanism)) {
    return <ProductDiscount earningMechanism={earningMechanism} />;
  }
  if (earningMechanismHelper.isTotalSpendOverTime(earningMechanism)) {
    return <TotalSpendOverTime earningMechanism={earningMechanism} />;
  }
  if (earningMechanismHelper.isTransactionDiscount(earningMechanism)) {
    return <TransactionDiscount earningMechanism={earningMechanism} />;
  }
  if (earningMechanismHelper.isVarietyDiscount(earningMechanism)) {
    return <VarietyDiscount earningMechanism={earningMechanism} />;
  }
  if (earningMechanismHelper.isVisits(earningMechanism)) {
    return <Visits earningMechanism={earningMechanism} />;
  }
  if (earningMechanismHelper.isLoyaltyEvent(earningMechanism)) {
    return <LoyaltyEvent earningMechanism={earningMechanism} />;
  }
  if (earningMechanismHelper.isMembershipEvent(earningMechanism)) {
    return <MembershipEvent earningMechanism={earningMechanism} />;
  }
  if (earningMechanismHelper.isVarietyPurchase(earningMechanism)) {
    return <VarietyPurchase earningMechanism={earningMechanism} />;
  }
  if (earningMechanismHelper.isVarietyPurchaseOverTime(earningMechanism)) {
    return <VarietyPurchaseOverTime earningMechanism={earningMechanism} />;
  }
  return <Typography color='error'>Something went wrong.</Typography>;
};
